import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/nnc/services/productionphase';
import { ModelProps } from '@/types';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SearchSchema } from '@/defaultschemas/search';
import { ProductionPhaseSchema } from '../../schemas/productionphase';
import UnitAPI from '@apps/localization/services/unit';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';
import { YesNoAutocompleteElement } from '@/components/atoms';
import DivisionAPI from '@apps/localization/services/division';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'unit',
      headerName: t('Unit'),
      flex: 1,
      renderCell: (params) => {
        return params.row.unit ? params.row.unit.label : '';
      },
    },
    {
      field: 'division_name',
      headerName: t('Identified Area'),
      flex: 1,
      // renderCell: (params) => {
      //   return params.row.division ? params.row.division.label : '';
      // },
    },
    {
      field: 'order',
      headerName: t('Order'),
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      type: 'boolean',
      sortable: false,
    },
  ];

  return (
    <ListPage
      schema={ProductionPhaseSchema}
      schemaSearch={SearchSchema}
      title={t('Production Phase')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'translations__name', sort: 'asc' }],
        },
      }}
      enablePersist={true}
      persistKey="productionphase-list"
      overrideSortField={(field) => {
        return field == 'name' ? 'translations__name' : field;
      }}
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 2 }}>
        <AsyncAutocompleteElement
          name="unit"
          label={t('Unit')}
          api={UnitAPI.select}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 2 }}>
        <AsyncAutocompleteElement
          api={DivisionAPI.select}
          name="division"
          label={t('Identified Area')}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 1 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </ListPage>
  );
}
